<h4 mat-dialog-title>
  {{title}}
</h4>

<div mat-dialog-content>
  <p>{{message}}</p>
</div>

<div mat-dialog-actions align="end">
  <button mat-raised-button color="warn" cdkFocusInitial (click)="onDismiss()">No</button>
  <button mat-raised-button color="primary" (click)="onConfirm()">Yes</button>
</div>